// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__LsF8J","image":"Header_image__3tDa1","name":"Header_name__1z9Ke","info":"Header_info__WBn3Q","infoRow":"Header_infoRow__1GgEo"};